<template>
	<div class="altStats">
		<div class="text">总共找到{{ data.length }}张图片</div>
		<div class="list">
			<data-list
				:table-style="{ name: 'webclient' }"
				:data="data"
				:columns="column"
				:height="300"
			></data-list>
			<!-- <div class="showMore">查看更多</div> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'altStats',
	props: ['data'],
	data() {
		return {
			column: [
				{
					label: '图片链接',
          showHover: true,
					bind: 'url',
				},
				{
					label: 'alt标题',
					bind: 'alt',
				},
			],
		};
	},
};
</script>

<style lang="scss" scoped>
.altStats {
	padding: 20px 30px;

	.text {
		margin-bottom: 10px;
		font-size: 15px;
		font-weight: 400;
		color: #333333;
	}

	.list {
		width: 700px;

		.data-list {
			border: 1px solid #dfe3e9;

			::v-deep .el-table {
				.el-table__body-wrapper {
					// 改变滚动条样式
					&::-webkit-scrollbar {
						width: 5px;
					}

					&::-webkit-scrollbar-thumb {
						background-color: #d8d8d8;
						border-radius: 2px;
					}

					&::-webkit-scrollbar-track {
						background-color: #fff;
						border-radius: 2px;
					}
				}
			}
		}

		// .showMore {
		// 	border: 1px solid #dfe3e9;
		// 	border-top: none;
		// }
	}
}
</style>
